import { createApp } from 'vue';
import router from './router.js';
import App from '../components/App.vue';

const vueAppEl = document.getElementById('vue-app');
const checkoutRootEl = document.getElementById('s7-checkout-root');

if (vueAppEl) {
  const app = createApp(App);
  app.use(router);
  app.mount('#vue-app');

  const currentPath = window.location.pathname;
  if (currentPath === '/afrekenen/') {
    router.push(currentPath);
  }
} else if (checkoutRootEl && checkoutRootEl.hasAttribute('data-s7-checkout')) {
  const app = createApp(App);
  app.use(router);
  app.mount('#s7-checkout-root');

  const currentPath = window.location.pathname;
  if (currentPath === '/afrekenen/') {
    router.push(currentPath);
  }
}
